var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTriCube = function SvgTriCube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30.805 51.887 29.5-16.962 29.5 16.962-29.5 16.963-29.5-16.963Z",
    fill: "#3F996F",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m30.813 51.888 29.5-16.963V1l-29.5 16.963v33.925Z",
    fill: "#51C58E",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m60.305 34.925 29.5 16.963V17.963L60.305 1v33.925Z",
    fill: "#5ADB9E",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m60.305 68.85 29.5-16.963V17.962l-29.5 16.963V68.85Z",
    fill: "#36835F",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m60.313 68.85-29.5-16.963V17.962l29.5 16.963V68.85Z",
    fill: "#48AF7E",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.805 17.963 60.305 1l29.5 16.963-29.5 16.962-29.5-16.962Z",
    fill: "#2D6E4F",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60 102.75 90 85.5l30 17.25L90 120l-30-17.25Z",
    fill: "#3F996F",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m60.008 102.75 30-17.25V51l-30 17.25v34.5Z",
    fill: "#51C58E",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m90 85.5 30 17.25v-34.5L90 51v34.5Z",
    fill: "#5ADB9E",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m90 119.999 30-17.25v-34.5l-30 17.25V120Z",
    fill: "#36835F",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m90.008 119.999-30-17.25v-34.5l30 17.25V120Z",
    fill: "#48AF7E",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60 68.25 90 51l30 17.25L90 85.5 60 68.25Z",
    fill: "#2D6E4F",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m.805 102.736 30-17.25 30 17.25-30 17.25-30-17.25Z",
    fill: "#3F996F",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m.812 102.737 30-17.25v-34.5l-30 17.25v34.5Z",
    fill: "#51C58E",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m30.805 85.487 30 17.25v-34.5l-30-17.25v34.5Z",
    fill: "#5ADB9E",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m30.805 119.986 30-17.251v-34.5l-30 17.25v34.501Z",
    fill: "#36835F",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m30.813 119.986-30-17.251v-34.5l30 17.25v34.501Z",
    fill: "#48AF7E",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m.805 68.236 30-17.25 30 17.25-30 17.25-30-17.25Z",
    fill: "#2D6E4F",
    stroke: "#2F353F",
    strokeMiterlimit: 1
  })));
};
export { SvgTriCube as ReactComponent };
export default "data:image/svg+xml;base64,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";